var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",attrs:{"id":"zhongzzck"}},[_c('div',{staticClass:"left"},[_c('zzleft',{on:{"playData":_vm.playObj}})],1),_vm._v(" "),_c('div',{staticClass:"right"},[_c('myVideo',{ref:"myVideo"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d8a7d97","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zhongzz/zhongzzck.vue
// module id = null
// module chunks = 